import React, { PureComponent } from "react"
import PropTypes from "prop-types"
import { Radium } from "higher-order-components"
import { WysiwygContent } from "components"

const ErrorScreen = Radium(({ scrapeError }) => (
  <div style={[styles.fill, ...styles.error]}>
    <WysiwygContent xmlString={scrapeError} theme="light" />
  </div>
))

export default class ScrapedPage extends PureComponent {
  render() {
    const { html } = this.props

    if (html) {
      return <ErrorScreen scrapeError={html} />
    }
  }
}

const styles = {
  fill: {
    width: "100vw",
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
    boxSizing: "border-box"
  },

  center: {
    alignItems: "center",
    justifyContent: "center"
  },

  error: {
    backgroundColor: "#d00",
    color: "#fff",
    padding: "4em",
    wordBreak: "break-word"
  }
}

ScrapedPage.propTypes = {
  html: PropTypes.string.isRequired
}



// WEBPACK FOOTER //
// ./src/containers/scraped-page/index.jsx